// Dependencies
import React, { Component} from 'react'
import PropTypes from 'prop-types'
import * as firebase from 'firebase'

class ContactButton extends Component {
    static propTypes = {
        formValues: PropTypes.shape({
            name: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
            formIncomplete: PropTypes.bool.isRequired
        }).isRequired,
    }


       
    constructor(props) {
        super(props)
        this.state = {
            isClicked: false
        }
        this.postToFireBase = this.postToFireBase.bind(this)
    }
    
    
    postToFireBase(event) {
        var message = {
            "name" : this.props.formValues.name,
            "email" : this.props.formValues.email,
            "message" : this.props.formValues.message,
            "html" : "<div>From:"+  this.props.name + "</div><div>Email: <a href='mailto:"+ 
            this.props.formValues.email+ "'>"+ this.props.formValues.email + 
            "</a></div><div>Date:" + new Date().getTime + "</div><div>Message:" +this.props.formValues +"</div>"
    
        }
        
        let contactReff = firebase.database().ref().child('contactMe')

        contactReff.push(message)
        console.log('Message -  ', message)
        this.setState({isClicked: true})
    }
    render(){
        const isEnabled = this.state.isClicked || this.props.formValues.formIncomplete;
        return (
            <button  
            className='pt-button pt-intent-success'
            disabled={isEnabled }
            onClick={this.postToFireBase}
            >
            Contact Me 
            <span className="pt-icon-standard pt-icon-arrow-right pt-align-right"></span>
            </button>
        )
    }
}
export default ContactButton


// WEBPACK FOOTER //
// ./src/components/contactForm/contactMeButton.jsx